import {
  Sizes,
  Styles,
  HippieChic,
  Classic,
  OnePiece,
  Large,
  Medium,
  Oval,
  Small,
  Cross,
  Twin,
} from "@components/Icons"
import React, { ButtonHTMLAttributes } from "react"
import * as S from "./elements"

const icons = {
  classic: <Classic />,
  onepiece: <OnePiece />,
  oval: <Oval />,
  hippiechic: <HippieChic />,
  twin: <Twin />,
  small: <Small />,
  medium: <Medium />,
  large: <Large />,
  allSizes: <Sizes />,
  allStyles: <Styles />,
}

export type FilterIcons = keyof typeof icons

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  status?: "active" | "idle" | "disabled"
  showDeactivate: boolean
  icon?: FilterIcons
}

export const Filter: React.FC<Props> = ({
  children,
  status = "idle",
  showDeactivate,
  icon,
  ...rest
}) => {
  return (
    <S.FilterContainer>
      <S.FilterCircle
        data-status={status}
        data-showdeactivate={showDeactivate ? "true" : "false"}
        {...rest}
      >
        {showDeactivate && (
          <S.Disable data-status={status}>
            <Cross />
          </S.Disable>
        )}
        {icon && icons[icon] && icons[icon]}
      </S.FilterCircle>
      <S.LabelEl>{children}</S.LabelEl>
    </S.FilterContainer>
  )
}
